import React, { useEffect, useState } from "react";

// Material UI Components
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// Local
import Menu from "../Components/Menu";
import { useDispatch } from "react-redux";
import { SET_NAVBAR_TITLE } from "action_creators/actioncreator";
import S3upload from "views/Contentmanagement/components/S3upload";
import Watermarking from "views/Contentmanagement/components/Watermarking";
import queryString from "query-string";
import { Redirect, Route } from "react-router-dom";
import Chatbot from "views/Components/chatbot/Chatbot";

// Styling
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "50px",
  },
}));

const Contentmanagement = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const profileData = JSON.parse(localStorage.getItem("profileData"));
  const account = profileData.account;
  let domain = JSON.parse(localStorage.getItem("internal_domains"))?.domains;
  let userEmail = JSON.parse(localStorage.getItem("profileData"))?.email;
  let hasDomain = domain?.some((res) => userEmail.includes(res));
  const [isInternal, setIsInternal] = useState(hasDomain);
  const history = require("react-router-dom").useHistory();



  useEffect(() => {
    dispatch(
      SET_NAVBAR_TITLE(
        isInternal ? account + " - File Management Services" : "File Management Services"
      )
    );
    let queryParams = queryString.parse(window.location.search);
    if (queryParams?.option === "s3upload") {
      setCurrentScreen("s3 Upload and Watermark");
    }
  }, []);

  // States
  const [currentScreen, setCurrentScreen] = useState("s3 Upload and Watermark");
  const file_management_services = sessionStorage.getItem("enabled_roles")
  ? JSON.parse(sessionStorage.getItem("enabled_roles")).includes("File Management Services")
    ? true
    : false
  : false;
  
  if (file_management_services) {


    const menuItems = ["s3 Upload and Watermark", "Lab Guide Watermarking"];

    const renderContent = () => {
      switch (currentScreen) {
        case "s3 Upload and Watermark":
          return <S3upload />;
        case "Lab Guide Watermarking":
          return <Watermarking />;
        default:
          return <S3upload />;
      }
    };

    return (
      <div>
        <Grid container alignItems="center" justify="flex-start">
          <Grid item>
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() => history.push("/settings")}
              style={{ margin: "16px 0" }}
              color="secondary"
              variant="outlined"
            >
              Back
            </Button>
          </Grid>
        </Grid>
        <Grid container className={classes.root}>
          <Grid item md={2}>
            <Menu
              items={menuItems}
              onItemClick={setCurrentScreen}
              currentScreen={currentScreen}
            />
          </Grid>

          <Grid item md={10}>
            {renderContent()}
          </Grid>
        </Grid>
        <Chatbot />
      </div>
    );
  } else {
    return (
      <Route>
        <Redirect to="/dashboard"></Redirect>
      </Route>
    );
  }
};

export default Contentmanagement;
